export const GET_STARASSIGNMENT_LIST= "GET_STARASSIGNMENT_LIST"
export const GET_STARTYPES_LIST= "GET_STARTYPES_LIST"
export const GET_STARASSIGNMENT_TYPE_CATEGORY = "GET_STARASSIGNMENT_TYPE_CATEGORY"
export const GET_STATE_LOADING = "GET_STATE_LOADING";
export const GET_STARASSIGNMENT_SEARCHAFFILIATES = "GET_STARASSIGNMENT_SEARCHAFFILIATES";
export const GET_CARDSLIST = "GET_CARDSLIST"
export const GET_LIST_HISTORICAL_TEMPLATE = "GET_LIST_HISTORICAL_TEMPLATE";
export const GET_POST_TEMPLATE = "GET_POST_TEMPLATE";
export const GET_DOWNLOAD_TEMPLATE = "GET_DOWNLOAD_TEMPLATE";
